function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M20 12.94C20 15.73 17.76 17.99 14.97 18H14.96H5.05C2.27 18 0 15.75 0 12.96V12.95C0 12.95 0.006 8.524 0.014 6.298C0.015 5.88 0.495 5.646 0.822 5.906C3.198 7.791 7.447 11.228 7.5 11.273C8.21 11.842 9.11 12.163 10.03 12.163C10.95 12.163 11.85 11.842 12.56 11.262C12.613 11.227 16.767 7.893 19.179 5.977C19.507 5.716 19.989 5.95 19.99 6.367C20 8.576 20 12.94 20 12.94Z",
  fill: "#0041BE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.4761 2.674C18.6101 1.042 16.9061 0 15.0301 0H5.05013C3.17413 0 1.47013 1.042 0.604128 2.674C0.410128 3.039 0.502128 3.494 0.825128 3.752L8.25013 9.691C8.77013 10.111 9.40013 10.32 10.0301 10.32C10.0341 10.32 10.0371 10.32 10.0401 10.32C10.0431 10.32 10.0471 10.32 10.0501 10.32C10.6801 10.32 11.3101 10.111 11.8301 9.691L19.2551 3.752C19.5781 3.494 19.6701 3.039 19.4761 2.674Z",
  fill: "#0041BE"
});

function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.6889da31.svg";
export { ForwardRef as ReactComponent };